import { call, put, takeLatest } from 'redux-saga/effects';
import SupportSearchAction, {
  SupportSearchTypes,
} from 'redux/actions/supportSearchAction';
import {
  searchAllKnowledge,
  getFilterKnowledgeBaseAndCategory,
} from 'services/knowledgeServices';
import BaseAction from '../actions/baseAction';

export function* getKnowledgeBaseAndCategoryFilter(action: any): any {
  const { knowledge_bases, categories } = action.params;
  try {
    const result = yield call(getFilterKnowledgeBaseAndCategory, action.params);
    if (result.status === 200) {
      yield put(
        SupportSearchAction.getKnowledgeBaseAndCategoryFilterSuccess(
          result.data,
          knowledge_bases,
          categories,
        ),
      );
    }
  } catch (error) {
    yield put(
      BaseAction.errorHandling({
        message: `GET_KNOWLEDGE_BASE_AND_CATEGORY_FILTER ${error}`,
      }),
    );
  }
}

export function* searchAllKnowledgeResult(action: any): any {
  try {
    const result = yield call(searchAllKnowledge, action.params);
    if (result.status === 200) {
      yield put(
        SupportSearchAction.searchAllKnowledgeResultSuccess(result.data),
      );
    }
  } catch (error) {
    yield put (SupportSearchAction.searchAllKnowledgeResultFail());
    yield put(
      BaseAction.errorHandling({
        message: `SEARCH_ALL_KNOWLEDGE_RESULT ${error}`,
      }),
    );
  }
}

export const watchSupportSearch = [
  takeLatest(SupportSearchTypes.GET_KNOWLEDGE_BASE_AND_CATEGORY_FILTER, getKnowledgeBaseAndCategoryFilter),
  takeLatest(SupportSearchTypes.SEARCH_ALL_KNOWLEDGE_RESULT, searchAllKnowledgeResult),
];
